import { render, staticRenderFns } from "./AzureDataFactory.vue?vue&type=template&id=54859dc7&"
import script from "./AzureDataFactory.vue?vue&type=script&lang=js&"
export * from "./AzureDataFactory.vue?vue&type=script&lang=js&"
import style0 from "./AzureDataFactory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports